// import React from "react";
// import { Table, Button, Form, Badge, Spinner, InputGroup } from "react-bootstrap";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./AdminFormAssignmentsPage.css";
// import Can from "../../components/Can";
// import useFormAssignments, { STATUS_VARIANTS } from "../../hooks/useFormAssignments";
// import FormAssignmentSummaryCards from "../../components/forms/FormAssignmentSummaryCards";
// import AssignFormModal from "../../components/forms/AssignFormModal";
// import ManageAssignedUsersModal from "../../components/forms/ManageAssignedUsersModal";

// // Admin's OWN page for "Form Assignments" -- built with Admin's own
// // markup/section structure (a management-console table with an inline
// // per-row breakdown, rather than the Product-List-styled card the
// // non-admin RoleFormAssignmentsPage.jsx uses), using the shared `unit-*`
// // classes that inherit Admin's teal theme ambiently via AdminLayout's
// // `.admin-teal-theme` wrapper (theme/adminTealOverrides.css) -- never a
// // hardcoded color here. ALL data/business logic (fetch, filters, save,
// // status transitions, the Assign Form modal) comes from the SAME
// // useFormAssignments() hook RoleFormAssignmentsPage.jsx uses.
// export default function AdminFormAssignmentsPage() {
//   const {
//     can, permissionsLoading, hasAnyAssignmentAccess,
//     assignments, total, loading, saving, busyId,
//     projectFilterOptions, users,
//     search, setSearch, statusFilter, setStatusFilter, projectFilter, setProjectFilter,
//     currentPage, setCurrentPage, totalPages,
//     form, selectedFormRow, showModal,
//     handleChange, openAdd, closeModal, handleFormChange, handleSave,
//     setStatus,
//     usersModalTarget, removeUserTarget, setRemoveUserTarget, removingUser,
//     assignedUsers, addUserIds, setAddUserIds, usersLoading,
//     openUsersModal, closeUsersModal, addUsersToAssignment, confirmRemoveUserFromAssignment,
//     availableUsersToAdd, fetchAssignments,
//   } = useFormAssignments();

//   if (permissionsLoading) {
//     return <div className="unit-page formassign-mgmt-theme"><div className="unit-loader"><Spinner animation="border" /></div></div>;
//   }

//   if (!hasAnyAssignmentAccess) {
//     return (
//       <div className="unit-page formassign-mgmt-theme">
//         <div className="unit-empty">
//           <div className="unit-empty-icon"><i className="fa-solid fa-lock" aria-hidden="true"></i></div>
//           <h5>Access denied</h5>
//           <p>You do not have permission to assign forms.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="unit-page admin-form-page formassign-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Form Management</div>
//           <h2>Form Assignments</h2>
//           <p>Manage and monitor form assignments across the organization.</p>
//         </div>
//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchAssignments} disabled={loading}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>
//           <Can moduleKey="form_assignments" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Assign Form
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <FormAssignmentSummaryCards
//         statusFilterActive={!!statusFilter}
//         onClearStatusFilter={() => { setCurrentPage(1); setStatusFilter(""); }}
//       />

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <h5 className="mb-0"><i className="fa-solid fa-file-signature assign-list-icon" aria-hidden="true"></i>Assignment Management</h5>
//         </div>

//         {/* Admin's own filter-row layout: full-width row of labeled controls,
//             distinct from Role page's single-line compact toolbar. */}
//         <div className="unit-filter-row admin-assignments-filter-row">
//           <Form.Group>
//             <Form.Label className="small mb-0">Search</Form.Label>
//             <InputGroup>
//               <InputGroup.Text aria-hidden="true"><i className="fa-solid fa-magnifying-glass"></i></InputGroup.Text>
//               <Form.Control
//                 placeholder="Assignment title..."
//                 aria-label="Search by assignment title"
//                 value={search}
//                 onChange={(e) => { setCurrentPage(1); setSearch(e.target.value); }}
//               />
//             </InputGroup>
//           </Form.Group>
//           <Form.Group>
//             <Form.Label className="small mb-0">Status</Form.Label>
//             <Form.Select value={statusFilter} onChange={(e) => { setCurrentPage(1); setStatusFilter(e.target.value); }}>
//               <option value="">All</option>
//               {Object.keys(STATUS_VARIANTS).map((s) => <option key={s} value={s}>{s}</option>)}
//             </Form.Select>
//           </Form.Group>
//           <Form.Group>
//             <Form.Label className="small mb-0">Project</Form.Label>
//             <Form.Select value={projectFilter} onChange={(e) => { setCurrentPage(1); setProjectFilter(e.target.value); }}>
//               <option value="">All</option>
//               {projectFilterOptions.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//             </Form.Select>
//           </Form.Group>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader"><Spinner animation="border" /><p>Loading assignments...</p></div>
//           ) : assignments.length === 0 ? (
//             <div className="unit-empty">
//               <div className="unit-empty-icon"><i className="fa-solid fa-clipboard-list" aria-hidden="true"></i></div>
//               <h5>No form assignments recorded yet</h5>
//               <p>Use "+ Assign Form" to send a published form to one or more employees.</p>
//             </div>
//           ) : (
//             <Table responsive bordered hover size="sm" className="unit-table admin-assignments-table">
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>Assignment / Form</th>
//                   <th>Scope</th>
//                   <th>Due</th>
//                   <th>Recipients / Submitted</th>
//                   <th>Status</th>
//                   <th className="text-end">Manage</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {assignments.map((row) => (
//                   <tr key={row.id}>
//                     <td className="text-muted small">#{row.id}</td>
//                     <td>
//                       <div><strong>{row.assignment_title}</strong> {!!row.is_mandatory && <Badge bg="warning" text="dark">Mandatory</Badge>}</div>
//                       <div className="small text-muted">{row.form_name} · v{row.version_number} · {row.form_type_name}</div>
//                     </td>
//                     <td className="small text-muted">
//                       {row.project_name || "—"}{row.project_module_name ? ` / ${row.project_module_name}` : ""}
//                     </td>
//                     <td className="small">{row.due_at ? new Date(row.due_at).toLocaleDateString() : "—"}</td>
//                     <td className="small">{row.assigned_count} recipient{row.assigned_count === 1 ? "" : "s"} — {row.submitted_count} submitted</td>
//                     <td><Badge bg={STATUS_VARIANTS[row.status] || "secondary"}>{row.status}</Badge></td>
//                     <td className="text-end">
//                       <div className="unit-actions justify-content-end" style={{ flexWrap: "wrap" }}>
//                         <Can moduleKey="form_assignments" actionKey="assign_users">
//                           <Button size="sm" variant="outline-primary" onClick={() => openUsersModal(row)}>
//                             <i className="fa-solid fa-users-gear" aria-hidden="true"></i>
//                             Recipients
//                           </Button>
//                         </Can>
//                         {row.status !== "ACTIVE" && row.status !== "CLOSED" && row.status !== "CANCELLED" && can("form_assignments", "activate") && (
//                           <Button size="sm" variant="outline-success" disabled={busyId === row.id} onClick={() => setStatus(row, "ACTIVE")}>
//                             <i className="fa-solid fa-play" aria-hidden="true"></i>
//                             Activate
//                           </Button>
//                         )}
//                         {row.status === "ACTIVE" && can("form_assignments", "close") && (
//                           <Button size="sm" variant="outline-secondary" disabled={busyId === row.id} onClick={() => setStatus(row, "CLOSED")}>
//                             <i className="fa-solid fa-lock" aria-hidden="true"></i>
//                             Close
//                           </Button>
//                         )}
//                         {(row.status === "DRAFT" || row.status === "ACTIVE") && can("form_assignments", "cancel") && (
//                           <Button size="sm" variant="outline-danger" disabled={busyId === row.id} onClick={() => setStatus(row, "CANCELLED")}>
//                             <i className="fa-solid fa-ban" aria-hidden="true"></i>
//                             Cancel
//                           </Button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">Showing <strong>{assignments.length}</strong> of <strong>{total}</strong> assignments</div>
//           {totalPages > 1 && (
//             <div className="unit-pagination d-flex gap-2">
//               <Button size="sm" variant="outline-secondary" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
//                 <i className="fa-solid fa-chevron-left" aria-hidden="true"></i>
//                 Prev
//               </Button>
//               <span className="align-self-center small">{currentPage} / {totalPages}</span>
//               <Button size="sm" variant="outline-secondary" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>
//                 Next
//                 <i className="fa-solid fa-chevron-right" aria-hidden="true"></i>
//               </Button>
//             </div>
//           )}
//         </div>
//       </div>

//       <AssignFormModal
//         show={showModal}
//         onClose={closeModal}
//         form={form}
//         users={users}
//         selectedFormRow={selectedFormRow}
//         saving={saving}
//         onChange={handleChange}
//         onFormChange={handleFormChange}
//         onSave={handleSave}
//       />

//       <ManageAssignedUsersModal
//         target={usersModalTarget}
//         onClose={closeUsersModal}
//         loading={usersLoading}
//         assignedUsers={assignedUsers}
//         availableUsersToAdd={availableUsersToAdd}
//         addUserIds={addUserIds}
//         onToggleAddUser={(id) => setAddUserIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id])}
//         onAddUsers={addUsersToAssignment}
//         removeUserTarget={removeUserTarget}
//         onRequestRemove={setRemoveUserTarget}
//         onCancelRemove={() => setRemoveUserTarget(null)}
//         onConfirmRemove={confirmRemoveUserFromAssignment}
//         removing={removingUser}
//       />
//     </div>
//   );
// }






import React, { useEffect } from "react";
import { Table, Button, Form, Badge, Spinner, InputGroup } from "react-bootstrap";
import "./AdminFormAssignmentsPage.css";
import Can from "../../components/Can";
import useFormAssignments, { STATUS_VARIANTS } from "../../hooks/useFormAssignments";
import FormAssignmentSummaryCards from "../../components/forms/FormAssignmentSummaryCards";
import AssignFormModal from "../../components/forms/AssignFormModal";
import ManageAssignedUsersModal from "../../components/forms/ManageAssignedUsersModal";
import JustAssignedLinksModal from "../../components/forms/JustAssignedLinksModal";
import PublicLinkSummaryCell from "../../components/forms/PublicLinkSummaryCell";
import EditAssignmentModal from "../../components/forms/EditAssignmentModal";
import AssignmentActionsMenu from "../../components/forms/AssignmentActionsMenu";
import AssignmentRowDetails from "../../components/forms/AssignmentRowDetails";
import StatusChip from "../../components/forms/StatusChip";
import AssignmentDragDropWorkspace from "../../components/forms/AssignmentDragDropWorkspace";
import { initialsOf, avatarColorFor } from "../../utils/avatar";

const TABS = [
  { key: "ALL", label: "All" },
  { key: "ASSIGNED_BY_ME", label: "Assigned By Me" },
  { key: "SUBMITTED", label: "Submitted" },
  { key: "OVERDUE", label: "Overdue" },
];

// KPI reduction (Forms Workspace polish pass): when embedded, show only
// these up front -- every other metric FormAssignmentSummaryCards already
// fetches stays available behind its own "More Metrics" toggle.
const ASSIGN_TAB_PRIMARY_KEYS = [
  "admin.allAssignments",
  "assigner.pendingReviews",
  "assigner.inProgressReviews",
  "assigner.submittedReviews",
  "assigner.overdueReviews",
  "admin.formReviewQueue",
];
const ASSIGN_TAB_LABEL_OVERRIDES = {
  "admin.allAssignments": "Total Assignments",
  "admin.formReviewQueue": "To Review",
};

// Admin's OWN page for "Form Assignments" -- built with Admin's own
// markup/section structure (a management-console table with an inline
// per-row breakdown, rather than the Product-List-styled card the
// non-admin RoleFormAssignmentsPage.jsx uses), using the shared `unit-*`
// classes that inherit Admin's teal theme ambiently via AdminLayout's
// `.admin-teal-theme` wrapper. ALL data/business logic (fetch, filters,
// save, status transitions, assignment and recipient modals) still comes
// from the SAME useFormAssignments() hook.
export default function AdminFormAssignmentsPage({ initialAssignTab, embedded = false } = {}) {
  const {
    can,
    viewMode,
    setViewMode,
    setActiveTab,
    editTarget,
    editForm,
    editSaving,
    closeEdit,
    handleEditFormChange,
    handleUpdateAssignment,
    permissionsLoading,
    hasAnyAssignmentAccess,
    assignments,
    total,
    loading,
    saving,
    busyId,
    projectFilterOptions,
    users,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    projectFilter,
    setProjectFilter,
    currentPage,
    setCurrentPage,
    totalPages,
    form,
    selectedFormRow,
    showModal,
    handleChange,
    openAdd,
    closeModal,
    handleFormChange,
    handleSave,
    setStatus,
    usersModalTarget,
    removeUserTarget,
    setRemoveUserTarget,
    removingUser,
    assignedUsers,
    addUserIds,
    setAddUserIds,
    usersLoading,
    openUsersModal,
    closeUsersModal,
    addUsersToAssignment,
    confirmRemoveUserFromAssignment,
    eligibleUsers, eligibleUsersTotal, eligibleUsersLoading,
    eligibleUsersSearch, searchEligibleUsers, loadMoreEligibleUsers, ELIGIBLE_USERS_PAGE_SIZE,
    fetchAssignments,
    linkBusyId, generatePublicLink, regeneratePublicLink, revokePublicLink,
    justAssignedLinks, closeJustAssignedLinks, generatedLinks,
  } = useFormAssignments();

  // Lets the consolidated Forms Workspace's Assign & Track tab deep-link
  // straight into the "Assigned By Me" pill (e.g. a legacy
  // /admin/forms-assigned-by-me bookmark redirected to
  // /admin/forms?tab=assign&view=assigned-by-me) without duplicating this
  // page's own tab state or data-fetching.
  useEffect(() => {
    if (initialAssignTab && TABS.some((t) => t.key === initialAssignTab)) {
      setActiveTab(initialAssignTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (permissionsLoading) {
    return (
      <div className="unit-page formassign-mgmt-theme">
        <div className="unit-loader formassign-page-loader">
          <Spinner animation="border" />
          <p>Checking permissions...</p>
        </div>
      </div>
    );
  }

  if (!hasAnyAssignmentAccess) {
    return (
      <div className="unit-page formassign-mgmt-theme">
        <div className="unit-empty formassign-access-denied">
          <div className="unit-empty-icon">
            <i className="fa-solid fa-lock" aria-hidden="true"></i>
          </div>
          <h5>Access denied</h5>
          <p>You do not have permission to assign forms.</p>
        </div>
      </div>
    );
  }

  const hasActiveFilters = !!(search || statusFilter || projectFilter);
  const resetFilters = () => {
    setCurrentPage(1);
    setSearch("");
    setStatusFilter("");
    setProjectFilter("");
  };

  return (
    <div className={`unit-page admin-form-page formassign-mgmt-theme ${embedded ? "fa-embedded" : ""}`}>

      <div className="formassign-heading-box">
        <div className="formassign-heading-content">
          <div className="formassign-heading-icon">
            <i className="fa-solid fa-user-check" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Form Management</div>
            <h2>Form Assignments</h2>
            <p>Manage and monitor form assignments across the organization.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button
            className="unit-btn unit-btn-light"
            onClick={fetchAssignments}
            disabled={loading}
          >
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Can moduleKey="form_assignments" actionKey="create">
            <Button
              className={`unit-btn ${viewMode === "dragdrop" ? "unit-btn-primary" : "unit-btn-light"}`}
              onClick={() => setViewMode(viewMode === "dragdrop" ? "table" : "dragdrop")}
            >
              <i className="fa-solid fa-hand-pointer" aria-hidden="true"></i>
              Drag &amp; Drop
            </Button>
            <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Assign Form
            </Button>
          </Can>
        </div>
      </div>

      <div className="formassign-summary-wrap">
        <FormAssignmentSummaryCards
          statusFilterActive={!!statusFilter}
          onClearStatusFilter={() => {
            setCurrentPage(1);
            setStatusFilter("");
          }}
        />
      </div>

      <div className="unit-card formassign-card">
        <div className="unit-toolbar formassign-toolbar">
          <div className="formassign-section-title">
            <div className="formassign-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="formassign-section-copy">
              <h5>Assignment Management</h5>
              <p>
                Search assignments, filter by status or project, manage recipients,
                and control the assignment lifecycle.
              </p>
            </div>
          </div>

          <div className="admin-assignments-filter-row">
            <Form.Group className="formassign-filter-group formassign-search-group">
              <Form.Label>Search</Form.Label>
              <InputGroup className="formassign-search">
                <InputGroup.Text aria-hidden="true">
                  <i className="fa-solid fa-magnifying-glass"></i>
                </InputGroup.Text>

                <Form.Control
                  placeholder="Assignment title..."
                  aria-label="Search by assignment title"
                  value={search}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setSearch(e.target.value);
                  }}
                />

                {search && (
                  <Button
                    className="formassign-clear-btn"
                    onClick={() => {
                      setCurrentPage(1);
                      setSearch("");
                    }}
                    title="Clear search"
                    aria-label="Clear search"
                  >
                    <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                  </Button>
                )}
              </InputGroup>
            </Form.Group>

            <Form.Group className="formassign-filter-group">
              <Form.Label>Status</Form.Label>
              <div className="formassign-select-wrap">
                <i
                  className="fa-solid fa-circle-check formassign-select-icon"
                  aria-hidden="true"
                ></i>
                <Form.Select
                  value={statusFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setStatusFilter(e.target.value);
                  }}
                >
                  <option value="">All Statuses</option>
                  {Object.keys(STATUS_VARIANTS).map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>

            <Form.Group className="formassign-filter-group">
              <Form.Label>Project</Form.Label>
              <div className="formassign-select-wrap">
                <i
                  className="fa-solid fa-diagram-project formassign-select-icon"
                  aria-hidden="true"
                ></i>
                <Form.Select
                  value={projectFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setProjectFilter(e.target.value);
                  }}
                >
                  <option value="">All Projects</option>
                  {projectFilterOptions.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading assignments...</p>
            </div>
          ) : assignments.length === 0 ? (
            <div className="unit-empty">
              <div className="unit-empty-icon">
                <i className="fa-solid fa-clipboard-list" aria-hidden="true"></i>
              </div>
              <h5>No form assignments recorded yet</h5>
              <p>Use “Assign Form” to send a published form to one or more employees.</p>

              <Can moduleKey="form_assignments" actionKey="create">
                <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
                  <i className="fa-solid fa-plus" aria-hidden="true"></i>
                  Assign Form
                </Button>
              </Can>
            </div>
          ) : (
            <Table
              responsive
              bordered
              hover
              size="sm"
              className="unit-table admin-assignments-table"
            >
              <thead>
                <tr>
                  <th>Assignment</th>
                  <th>Form</th>
                  <th>Recipients</th>
                  <th>Scope</th>
                  <th>Due Date</th>
                  <th>Progress</th>
                  <th>Status</th>
                  <th>Public Link</th>
                  <th className="text-end formassign-actions-header">Manage</th>
                </tr>
              </thead>

              <tbody>
                {assignments.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <span className="formassign-id-chip">#{row.id}</span>
                    </td>

                    <td>
                      <div className="formassign-name-box">
                        <div className="formassign-letter">
                          {row.assignment_title?.charAt(0)?.toUpperCase() || "A"}
                        </div>

                        <div className="formassign-name-copy">
                          <div className="formassign-title-line">
                            <strong title={row.assignment_title}>
                              {row.assignment_title}
                            </strong>

                            {!!row.is_mandatory && (
                              <Badge className="formassign-mandatory-badge">
                                <i
                                  className="fa-solid fa-circle-exclamation me-1"
                                  aria-hidden="true"
                                ></i>
                                Mandatory
                              </Badge>
                            )}
                          </div>

                          <small>
                            {row.form_name} · v{row.version_number} · {row.form_type_name}
                          </small>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="formassign-scope-wrap">
                        {row.project_name ? (
                          <span className="formassign-scope-chip">
                            <i
                              className="fa-solid fa-diagram-project"
                              aria-hidden="true"
                            ></i>
                            {row.project_name}
                          </span>
                        ) : (
                          <span className="formassign-muted">No project</span>
                        )}

                        {row.project_module_name && (
                          <span className="formassign-module-chip">
                            <i className="fa-solid fa-cubes" aria-hidden="true"></i>
                            {row.project_module_name}
                          </span>
                        )}
                      </div>
                    </td>

                    <td>
                      {row.due_at ? (
                        <span className="formassign-due-chip">
                          <i className="fa-regular fa-calendar" aria-hidden="true"></i>
                          {new Date(row.due_at).toLocaleDateString()}
                        </span>
                      ) : (
                        <span className="formassign-muted">No due date</span>
                      )}
                    </td>

                    <td>
                      <div className="formassign-recipient-summary">
                        <span className="formassign-recipient-count">
                          <i className="fa-solid fa-users" aria-hidden="true"></i>
                          {row.assigned_count} recipient
                          {row.assigned_count === 1 ? "" : "s"}
                        </span>

                        <span className="formassign-submitted-count">
                          <i
                            className="fa-solid fa-circle-check"
                            aria-hidden="true"
                          ></i>
                          {row.submitted_count} submitted
                        </span>
                      </div>
                    </td>

                    <td>
                      <Badge
                        bg={STATUS_VARIANTS[row.status] || "secondary"}
                        className={`formassign-status-badge formassign-status-${String(
                          row.status || ""
                        ).toLowerCase()}`}
                      >
                        {row.status}
                      </Badge>
                    </td>

                    <td>
                      <PublicLinkSummaryCell
                        row={row}
                        linkBusyId={linkBusyId}
                        onGenerateLink={generatePublicLink}
                        onRegenerateLink={regeneratePublicLink}
                        onRevokeLink={revokePublicLink}
                        onManageLinks={openUsersModal}
                        generatedLinks={generatedLinks}
                      />
                    </td>

                    <td className="formassign-actions-cell">
                      <div className="unit-actions formassign-actions">
                        <Can moduleKey="form_assignments" actionKey="assign_users">
                          <Button
                            className="formassign-action-btn formassign-action-recipients"
                            onClick={() => openUsersModal(row)}
                            title="Manage Recipients & Public Links"
                            aria-label={`Manage recipients for ${row.assignment_title}`}
                          >
                            <i
                              className="fa-solid fa-users-gear"
                              aria-hidden="true"
                            ></i>
                          </Button>
                        </Can>

                        {row.status !== "ACTIVE" &&
                          row.status !== "CLOSED" &&
                          row.status !== "CANCELLED" &&
                          can("form_assignments", "activate") && (
                            <Button
                              className="formassign-action-btn formassign-action-activate"
                              disabled={busyId === row.id}
                              onClick={() => setStatus(row, "ACTIVE")}
                              title="Activate"
                              aria-label={`Activate ${row.assignment_title}`}
                            >
                              {busyId === row.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <i className="fa-solid fa-play" aria-hidden="true"></i>
                              )}
                            </Button>
                          )}

                        {row.status === "ACTIVE" &&
                          can("form_assignments", "close") && (
                            <Button
                              className="formassign-action-btn formassign-action-close"
                              disabled={busyId === row.id}
                              onClick={() => setStatus(row, "CLOSED")}
                              title="Close"
                              aria-label={`Close ${row.assignment_title}`}
                            >
                              {busyId === row.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <i className="fa-solid fa-lock" aria-hidden="true"></i>
                              )}
                            </Button>
                          )}

                        {(row.status === "DRAFT" || row.status === "ACTIVE") &&
                          can("form_assignments", "cancel") && (
                            <Button
                              className="formassign-action-btn formassign-action-cancel"
                              disabled={busyId === row.id}
                              onClick={() => setStatus(row, "CANCELLED")}
                              title="Cancel"
                              aria-label={`Cancel ${row.assignment_title}`}
                            >
                              {busyId === row.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <i className="fa-solid fa-ban" aria-hidden="true"></i>
                              )}
                            </Button>
                          )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{assignments.length}</strong> of <strong>{total}</strong>{" "}
            assignments
          </div>

          {totalPages > 1 && (
            <div className="unit-pagination formassign-pagination">
              <Button
                className="formassign-page-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
                title="Previous page"
              >
                <i
                  className="fa-solid fa-chevron-left"
                  aria-hidden="true"
                ></i>
              </Button>

              <span className="formassign-page-number">
                {currentPage} / {totalPages}
              </span>

              <Button
                className="formassign-page-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
                title="Next page"
              >
                <i
                  className="fa-solid fa-chevron-right"
                  aria-hidden="true"
                ></i>
              </Button>
            </div>
          )}
        </div>
      </div>

      <AssignFormModal
        show={showModal}
        onClose={closeModal}
        form={form}
        users={users}
        selectedFormRow={selectedFormRow}
        saving={saving}
        onChange={handleChange}
        onFormChange={handleFormChange}
        onSave={handleSave}
      />

      <EditAssignmentModal
        target={editTarget}
        form={editForm}
        saving={editSaving}
        onChange={handleEditFormChange}
        onClose={closeEdit}
        onSave={handleUpdateAssignment}
        users={users}
      />

      <ManageAssignedUsersModal
        target={usersModalTarget}
        onClose={closeUsersModal}
        loading={usersLoading}
        assignedUsers={assignedUsers}
        eligibleUsers={eligibleUsers}
        eligibleUsersTotal={eligibleUsersTotal}
        eligibleUsersLoading={eligibleUsersLoading}
        eligibleUsersPageSize={ELIGIBLE_USERS_PAGE_SIZE}
        eligibleUsersSearch={eligibleUsersSearch}
        onSearchEligibleUsers={searchEligibleUsers}
        onLoadMoreEligibleUsers={loadMoreEligibleUsers}
        addUserIds={addUserIds}
        onToggleAddUser={(id) =>
          setAddUserIds((prev) =>
            prev.includes(id)
              ? prev.filter((x) => x !== id)
              : [...prev, id]
          )
        }
        onAddUsers={addUsersToAssignment}
        removeUserTarget={removeUserTarget}
        onRequestRemove={setRemoveUserTarget}
        onCancelRemove={() => setRemoveUserTarget(null)}
        onConfirmRemove={confirmRemoveUserFromAssignment}
        removing={removingUser}
        linkBusyId={linkBusyId}
        onGenerateLink={generatePublicLink}
        onRegenerateLink={regeneratePublicLink}
        onRevokeLink={revokePublicLink}
        generatedLinks={generatedLinks}
      />

      <JustAssignedLinksModal
        links={justAssignedLinks}
        onClose={closeJustAssignedLinks}
      />
    </div>
  );
}
